import { useMutateData } from "shared/services/base.service";
const BaseServicePathUpload = process.env.REACT_APP_API_UPLOAD + "/inventory-management-upload";
const BaseServicePath = process.env.REACT_APP_API_INVENTORY;

const UploadRPkgContApiService = () => ({
  useUploadRPkgContUploadRPgMutation: () => {
    const { mutate } = useMutateData({
      invalidateKeys: [],
    });
    return async uploadData => {
      return await mutate({
        url: `${BaseServicePathUpload}/std-movement-excel`,
        // url: `${BaseServicePath}/std-movement-excel`,

        data: uploadData,
        method: "POST",
      });
    };
  },
  useUploadRPkgContUploadContMutation: () => {
    const { mutate } = useMutateData({
      invalidateKeys: [],
    });
    return async uploadData => {
      return await mutate({
        url: `${BaseServicePathUpload}/shipment-container-excel-upload`,
        // url: `${BaseServicePath}/shipment-container-excel-upload`,
        data: uploadData,
        method: "POST",
      });
    };
  },
});

export const { useUploadRPkgContUploadRPgMutation, useUploadRPkgContUploadContMutation } = UploadRPkgContApiService();
